import { QueryBoundary, Loader } from '@mews-commander/ui';
import { SentryTeams } from '@mews/enums';
import { SentryErrorBoundary } from '@mews/framework';
import { Container } from '@optimus-web/core';
import { TrialBalanceTable } from './components/TrialBalanceTable';

export const TrialBalance = () => (
    <SentryErrorBoundary team={SentryTeams.Accounting} fallback={<Loader />}>
        <Container padding={['200', '400']}>
            <QueryBoundary loader="inline">
                <TrialBalanceTable />
            </QueryBoundary>
        </Container>
    </SentryErrorBoundary>
);
